import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Capacitor } from "@capacitor/core";

import {
    login,
    loginWithGoogle,
} from "../services/auth";

export default function Login() {

    const navigate = useNavigate();

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");

    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const isNative = Capacitor.isNativePlatform();

    async function handleLogin(e) {
        e.preventDefault();
        console.log("Login button pressed");

        setError("");

        try {

            setLoading(true);
            console.log("Calling login()");

            await login(email, password);
            localStorage.removeItem("completedActivities");


            navigate("/");

        } catch (err) {

            switch (err.code) {

                case "auth/invalid-credential":
                case "auth/wrong-password":
                case "auth/user-not-found":
                    setError("Incorrect email or password.");
                    break;

                case "auth/invalid-email":
                    setError("Please enter a valid email.");
                    break;

                default:
                    console.error("Login error:", err);
                    setError(`${err.code}: ${err.message}`);
            }

        } finally {

            setLoading(false);

        }
    }

    async function handleGoogleLogin() {

        setError("");

        try {

            await loginWithGoogle();

            localStorage.removeItem("completedActivities");

            navigate("/");

        } catch (err) {

            console.error("Google login:", err);
            setError(`${err.code}: ${err.message}`);

        }

    }

    return (

        <div
            className="page"
            style={{
                paddingTop: "calc(env(safe-area-inset-top) + 16px)"
            }}
        >
            <Link
                to="/"
                style={{
                    display: "inline-block",
                    marginTop: "40px"
                }}
            >
                ← Home
            </Link>

            <h1>Welcome Back</h1>

            <p>
                Sign in to save progress and view learning journal.
            </p>

            <form onSubmit={handleLogin}>

                <div style={{ marginBottom: "20px" }}>
                    <label>Email</label>

                    <input
                        type="email"
                        required
                        value={email}
                        onChange={(e) =>
                            setEmail(e.target.value)
                        }
                    />
                </div>

                <div style={{ marginBottom: "20px" }}>
                    <label>Password</label>

                    <input
                        type="password"
                        required
                        value={password}
                        onChange={(e) =>
                            setPassword(e.target.value)
                        }
                    />
                </div>

                {error && (
                    <p style={{ color: "red" }}>
                        {error}
                    </p>
                )}

                <button
                    type="submit"
                    disabled={loading}
                >
                    {loading
                        ? "Signing In..."
                        : "Log In"}
                </button>

            </form>

            {!isNative && (

                <button
                    onClick={handleGoogleLogin}
                >
                    Continue with Google
                </button>

            )}

            <p>

                <Link to="/forgot-password">
                    Forgot Password ?
                </Link> (or previously signed in with Google on the web)

            </p>

            <p>

                Don't have an account?{" "}

                <Link to="/signup">
                    Create one

                </Link>

            </p>

        </div>

    );

}